module.exports = __webpack_public_path__ + "img/File.b577a89b.svg";